import { Time } from "@angular/common";

export class DadosAcumuloCargo {
    numeroInscricao: number;
    codigoConcurso: number;
    acumulaCargo: boolean = false;
    codigoEsfera: number;
    dataAdmissao: Date;
    codigoTipoVinculo: number;
    codigoOrgaoVinculo: number;
    cargoExerce: string;
    trabalhaEscalaPlantao: boolean;
    descricaoEscalaPlantao: string;
    cargaHoraria: string;
    d2e1: Time;
    d2s1: Time;
    d2e2: Time;
    d2s2: Time;
    d3e1: Time;
    d3s1: Time;
    d3e2: Time;
    d3s2: Time;
    d4e1: Time;
    d4s1: Time;
    d4e2: Time;
    d4s2: Time;
    d5e1: Time;
    d5s1: Time;
    d5e2: Time;
    d5s2: Time;
    d6e1: Time;
    d6s1: Time;
    d6e2: Time;
    d6s2: Time;
    dse1: Time;
    dss1: Time;
    dse2: Time;
    dss2: Time;
    dde1: Time;
    dds1: Time;
    dde2: Time;
    dds2: Time;
    estaLicencaDisponibilidade: boolean;
    cargoLicenca: string;
    orgaoLicenca: string;
    estaAposentado: boolean;
    cargoAposentadoria: string;
    orgaoAposentadoria: string;
    aposentadoriaInvalidez: boolean;
    exerceComercio: boolean = false;
    declaracaoConhecimento: boolean = false;
}


// WEBPACK FOOTER //
// ./src/app/models/dadosAcumuloCargo.model.ts